import { forwardRef, type Ref, type SVGProps } from "react";
const IconReorderOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M12 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6m1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M15 25a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M20 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6m1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M23 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M20 28a3 3 0 1 0 0-6 3 3 0 0 0 0 6m1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconReorderOutlineSVG);
ForwardRef.displayName = "IconReorderOutline";
export { ForwardRef as IconReorderOutline };
